<template>
  <div class="topup-tip-popup">
    <md-popup v-model="dialogVisible">
      <div class="topup-tip-icon">
        <img src="../../assets/image/product/icon_attention.png">
      </div>
      <div class="topup-tip-text">
        {{ $t('tip') }}
      </div>
      <div class="topup-tip-button">
        <md-button type="primary" round @click="switchRoute('UserTopup')">
          {{ $t('yes') }}
        </md-button>
      </div>
      <div class="topup-tip-button">
        <md-button type="default" round @click="$emit('hideDialog')">
          {{ $t('no') }}
        </md-button>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { Button, Popup, Dialog } from 'mand-mobile'
import dialogMixins from '@/mixins/dialog'

export default {
  i18n: {
    messages: {
      en: {
        tip: 'Your balance is not enough, would you like to top up first?',
        yes: 'Yes',
        no: 'No',
      },
      id: {
        tip: 'Nominal anda tidak mencukupi, penyaluran dana sekarang?',
        yes: 'Ya',
        no: 'Tidak',
      },
    },
  },
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
  },
  mixins: [dialogMixins],
  methods: {
    switchRoute(name) {
      this.$router.push({ name: name })
    },
  },
}
</script>

<style scoped lang="stylus">
.topup-tip-popup /deep/ {
  .md-popup-box {
    width: 90%;
    padding: 60px 30px;
    background-color: #fff;
    border-radius: 6px;
  }
  .topup-tip-icon {
    text-align: center;
    margin-bottom: 25px;
    img {
      width: 60px;
      height: 60px;
    }
  }
  .topup-tip-text {
    margin-bottom: 30px;
  }
  .topup-tip-button .md-button {
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>
